// ** Icons Import
import { Heart } from 'react-feather'
import useJwt from '@src/auth/jwt/useJwt'

const Footer = () => {
  return (
    <p className='clearfix mb-0'>
      <span className='float-md-start d-block d-md-inline-block mt-25 pl-25'>
        COPYRIGHT © {new Date().getFullYear()}{' '}
        <a href='https://www.junji.gob.cl/' target='_blank' rel='noopener noreferrer'>
          JUNJI
        </a>
      </span>
      <span>
        <span className='float-md-end d-none d-md-block'>
          V. {useJwt.getVersion()}
        </span>
      </span>
    </p>
  )
}

export default Footer
